import Link from 'components/link/Link';
import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';

import { IStatsLink } from 'source/NFR.types';

const StatsLink: React.FC<IStatsLink> = ({ image, title, link }) => (
  <div className="stats-link">
    <div className="stats-link--top">
      <Image className="stats-link--image" {...imageSizes.statsLink} {...image} />
      {title && <h2 className="stats-link--title">{title}</h2>}
    </div>
    {link && <Link className="stats-link--link" {...link} />}
  </div>
);

StatsLink.displayName = 'StatsLink';

export default StatsLink;
